import { render, staticRenderFns } from "./TheLockPage.vue?vue&type=template&id=b2398c08&"
import script from "./TheLockPage.vue?vue&type=script&lang=js&"
export * from "./TheLockPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports